import React from "react";

import "./Reports.scss";

import ReportsSidePanel from "../../components/Reports/SidePanel";
import ReportsContent from "../../components/Reports/Content";

const Reports = (props) => {
  const { app, data, reports } = props;
  const { storeStats } = data;
  const {
    type,
    stores,
    selectedStores,
    selectedAttributes,
    dailyPatterns,
    recentTrends,
    recentTrendsStats,
  } = reports;

  return (
    <div className="reports">
      <ReportsSidePanel
        type={type}
        stores={stores}
        selectedStores={selectedStores}
        selectedAttributes={selectedAttributes}
      />
      <ReportsContent
        type={type}
        stores={stores}
        selectedStores={selectedStores}
        selectedAttributes={selectedAttributes}
        storeStats={storeStats}
        dailyPatterns={dailyPatterns}
        recentTrends={recentTrends}
        recentTrendsStats={recentTrendsStats}
      />
    </div>
  );
};

export default Reports;
